import { DateRangeDropdownV2 } from '@/components/custom/erp';
import DocumentNumberRange from '../DocumentNumberRange';
import { Label } from '@/components/ui/label';

const BasicInfo = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-2'>
        <div className='mb-4'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
            <div className='w-1/2'>
              <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
            </div>
          </div>
        </div>

        <div className='mb-4'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Số c/từ (từ/đến):</Label>
            <DocumentNumberRange fromDocumentNumberName='so_ct1' toDocumentNumberName='so_ct2' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
